import Axios from "../utils/axiosInterceptor";
import { DOCUMENTS } from "../utils/constants";

export type BillHeaderOcr = {
  uhid?: string;
  patientName?: string;
  gender?: string;
  age?: string;
  phone?: string;
  address?: string;
  payer?: string;
  billNo?: string;
  consultant?: string;
  admissionCategory?: string;
  doa?: string;
  dod?: string;
  billDate?: string;
  roomNo?: string;
};

export type BillHeaderOcrResponse = {
  billHeaders?: BillHeaderOcr[];
};

export const fetchBillHeaderOcr = async (
  billUrl: string,
): Promise<BillHeaderOcrResponse> => {
  const res = await Axios.post(DOCUMENTS.OCR_BILL_HEADER, { billUrl });
  return res.data;
};
